var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 7.983C20 3.593 16.4 0 12 0S4 3.593 4 7.983c0 2.595 1.2 4.89 3.1 6.287L6 22.852c-.1.4.1.799.4.998.3.2.7.2 1.1 0l4.5-2.694 4.5 2.694c.1.1.3.1.5.1s.4-.1.5-.2c.3-.2.5-.598.4-.997l-1.1-8.483c2-1.397 3.2-3.692 3.2-6.287m-14 0c0-3.293 2.7-5.987 6-5.987s6 2.694 6 5.987-2.7 5.988-6 5.988-6-2.694-6-5.988m6.5 11.177 3.2 1.896-.7-5.688q-1.35.6-3 .599c-1.65-.001-2.1-.2-3-.599l-.7 5.688 3.2-1.896c.3-.2.7-.2 1 0",
  clipRule: "evenodd"
})));
export default SvgAward;